/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { ComponentCanDeactivate } from './component-can-deactivate';
import { AbstractControl } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive()
export abstract class ReactiveFormCanDeactivate extends ComponentCanDeactivate {
  abstract get form(): AbstractControl;

  abstract isSubmitted: boolean;

  canDeactivate(): boolean {
    return this.isSubmitted || !this.form.dirty;
  }
}
